module.exports = __webpack_public_path__ + "img/battery-color.6b397ac3.svg";